import React from "react";
import { Input } from "antd";

const LeftMenuLanding = (props) => {
    return (
        <Input
            placeholder="Buscar..."
            className="w-1/3 rounded-lg bg-gray-100"
        />
    );
};

export default LeftMenuLanding;